import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Grid } from "@mui/material";
import isEqual from "react-fast-compare";
import Table from "../../common/tableWithBackEndPagination";
import ConfirmDialoag from "../../common/ConfirmDialoag";
import Loader from "../../../Layout/Loader";
import Button from "../../common/Button";
import TextField from "../../common/TextField";
import AddModelModal from "./addModel";
import { PaginationConfig } from "../../../Helpers";

let source;

const formDefaultState = {
  makeName: "",
  modelName: "",
  parentId: 0,
};

const modelDataFormat = (data, parentId, id) => ({
  ...(id != null ? { id } : {}),
  makeName: data?.makeName ? String(data.makeName).trim() : "",
  modelName: data?.modelName ? String(data.modelName).trim() : "",
  parentId: parentId ?? 0,
});

class ModelsList extends Component {
  constructor() {
    super();
    this.state = {
      ...PaginationConfig,
      pageSize: 50,
      selectedModel: "",
      addOption: false,
      editOption: false,
      defaultModelList: false,
      onDeleteConfirmation: false,
      tableData: [],
      pagData: "",
      form: { ...formDefaultState },
      isVisableModelBtn: false,
      isVisableModelBtnforEdit: false,
      loading: false,
      allMakes: [],
      makesLoading: false,
    };
    this.makesPagination = {
      page: 1,
      search: "",
      hasNext: false,
      loading: false,
    };
    this.makesSearchTimer = null;
  }

  componentDidMount() {
    this.getModelsData();
  }

  componentWillUnmount() {
    if (source) {
      source.cancel();
    }
    if (this.makesSearchTimer) {
      clearTimeout(this.makesSearchTimer);
    }
  }

  getModelsData = () => {
    const { page, pageSize, itemSearch } = this.state;
    if (!this.props.logInUser?.id) return;

    this.setState({ loading: true });
    const apiCall = `/api/models/get?page=${page}&limit=${pageSize}&search=${encodeURIComponent(
      itemSearch || "",
    )}`;
    source = axios.CancelToken.source();

    axios
      .get(apiCall, { cancelToken: source.token })
      .then((response) => {
        const res = response.data;
        if (res.status === "success") {
          const udata = res.data?.data || [];
          this.setState({
            tableData: udata,
            defaultModelList: true,
            pagData: res.data,
            loading: false,
          });
        } else if (res?.statusCode === "440") {
          window.location.replace("/login");
        } else if (res.statusCode) {
          const err = res?.message?.split(":");
          if (err?.[1]) {
            toast.error(this.props.translate(err[1].replace(")", "")));
          }
          this.setState({ loading: false, defaultModelList: true });
        }
      })
      .catch(() => {
        this.setState({ loading: false, defaultModelList: true });
      });
  };

  fetchMakesPage = async (page = 1, search = "") => {
    const response = await axios.get(
      `/api/makes/get?page=${page}&limit=20&make=${encodeURIComponent(search)}`,
    );
    const res = response.data;
    const payload = res?.data || res || {};
    const list = Array.isArray(payload?.data)
      ? payload.data
      : Array.isArray(payload)
        ? payload
        : [];
    const total = parseInt(payload?.total, 10) || 0;
    const hasNext = Boolean(payload?.hasNext ?? total > page * 20);
    const options = list.map((item) => ({
      id: item.id,
      key: item.makeName,
      label: item.makeName,
      value: item.makeName,
    }));
    return { options, hasNext };
  };

  fetchMakes = async (search = "") => {
    try {
      this.setState({ makesLoading: true });
      const { options, hasNext } = await this.fetchMakesPage(1, search);
      this.makesPagination = { page: 1, search, hasNext, loading: false };
      this.setState({ allMakes: options, makesLoading: false });
    } catch (error) {
      this.setState({ allMakes: [], makesLoading: false });
    }
  };

  searchMakesList = (search = "") => {
    if (this.makesSearchTimer) {
      clearTimeout(this.makesSearchTimer);
    }
    this.makesSearchTimer = setTimeout(() => {
      this.fetchMakes(search);
    }, 300);
  };

  loadMoreMakes = async () => {
    const pag = this.makesPagination || {};
    if (!pag.hasNext || pag.loading) return;
    this.makesPagination.loading = true;
    this.setState({ makesLoading: true });
    try {
      const nextPage = pag.page + 1;
      const { options, hasNext } = await this.fetchMakesPage(
        nextPage,
        pag.search || "",
      );
      const merged = [...(this.state.allMakes || []), ...options];
      this.makesPagination = {
        page: nextPage,
        search: pag.search,
        hasNext,
        loading: false,
      };
      this.setState({ allMakes: merged, makesLoading: false });
    } catch (error) {
      this.makesPagination.loading = false;
      this.setState({ makesLoading: false });
    }
  };

  removeModel = (selected) => {
    this.setState({
      onDeleteConfirmation: true,
      selectedModel: selected?.[0] || selected,
    });
  };

  deleteItem = () => {
    const { selectedModel } = this.state;
    if (!selectedModel?.id) return;

    fetch(`/api/models/${selectedModel.id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.status === "success") {
          toast.success(this.props.translate("deletedSuccessfully"));
          this.getModelsData();
        } else if (res?.statusCode === "440") {
          window.location.replace("/login");
        } else if (res.statusCode) {
          const err = res?.message?.split(":");
          if (err?.[1]) {
            toast.error(this.props.translate(err[1].replace(")", "")));
          }
        }
      })
      .catch(() => {
        toast.error(this.props.translate("somethingwentWrong"));
      });

    this.setState({
      form: { ...formDefaultState },
      onDeleteConfirmation: false,
      addOption: false,
      defaultModelList: true,
    });
  };

  onCancel = () => {
    this.setState({ onDeleteConfirmation: false });
  };

  handleChangeRowsPerPage = (value) => {
    this.setState({ pageSize: value }, () => this.getModelsData());
  };

  handleChangePage = (value) => {
    this.setState({ page: value }, () => this.getModelsData());
  };

  SearchItem = (searchValue) => {
    if (source) {
      source.cancel();
    }
    this.setState({ page: 1, itemSearch: searchValue }, () =>
      this.getModelsData(),
    );
  };

  checkFloteNumber(n) {
    return Number(n) === n && n % 1 !== 0;
  }

  setPagination = (user) => {
    if (this.state.pagData) {
      const nUser = { ...user };
      const lastPage = nUser.total / this.state.pageSize;
      const IsFloate = this.checkFloteNumber(lastPage);
      delete nUser.data;
      nUser.pageSize = this.state.pageSize;
      nUser.lastPage = IsFloate ? parseInt(lastPage + 1) : lastPage;
      return nUser;
    }
    return {};
  };

  addModel = () => {
    this.setState(
      {
        selectedModel: "",
        editOption: false,
        addOption: true,
        form: { ...formDefaultState, parentId: 0 },
        defaultModelList: false,
        isVisableModelBtn: false,
        isVisableModelBtnforEdit: false,
      },
      () => this.fetchMakes(""),
    );
  };

  handleChange = (name) => (event) => {
    const value = event?.target?.value ?? "";
    this.setState(
      (preState) => ({
        form: {
          ...preState.form,
          [name]: value,
        },
      }),
      () => this.checkRequiredFields(),
    );
  };

  handleMakeChange = (name, value) => {
    const makeName = value?.label || value?.key || value?.makeName || "";
    this.setState(
      (preState) => ({
        form: {
          ...preState.form,
          makeName,
        },
      }),
      () => this.checkRequiredFields(),
    );
  };

  checkRequiredFields() {
    const { makeName, modelName } = this.state.form;
    const { selectedModel, editOption } = this.state;
    const baseline = editOption
      ? {
          makeName: selectedModel?.makeName || "",
          modelName: selectedModel?.modelName || "",
        }
      : formDefaultState;
    const changed = !isEqual(
      { makeName: makeName || "", modelName: modelName || "" },
      { makeName: baseline.makeName || "", modelName: baseline.modelName || "" },
    );
    if (makeName?.trim() && modelName?.trim()) {
      this.setState({ isVisableModelBtn: true });
      if (changed) {
        this.setState({ isVisableModelBtnforEdit: true });
      } else {
        this.setState({ isVisableModelBtnforEdit: false });
      }
    } else {
      this.setState({
        isVisableModelBtn: false,
        isVisableModelBtnforEdit: false,
      });
    }
  }

  ag_submit = () => {
    const obj = modelDataFormat(this.state.form, 0);

    fetch("/api/models", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.status === "success") {
          toast.success(this.props.translate("createdSuccessfully"));
        } else if (res?.statusCode === "440") {
          window.location.replace("/login");
        } else if (res.statusCode) {
          const err = res?.message?.split(":");
          if (err?.[1]) {
            toast.error(this.props.translate(err[1].replace(")", "")));
          }
        }
      })
      .catch(() => {
        toast.error(this.props.translate("somethingwentWrong"));
      });

    this.setState(
      {
        addOption: false,
        form: { ...formDefaultState },
        defaultModelList: true,
        allMakes: [],
      },
      () => this.getModelsData(),
    );
  };

  modalControle = () => {
    this.setState({
      addOption: false,
      editOption: false,
      selectedModel: "",
      defaultModelList: true,
      isVisableModelBtn: false,
      isVisableModelBtnforEdit: false,
      form: { ...formDefaultState },
      allMakes: [],
    });
  };

  makeSelection = (item) => {
    if (!item) return;

    this.setState(
      {
        editOption: true,
        selectedModel: item,
        defaultModelList: false,
        form: {
          makeName: item.makeName || "",
          modelName: item.modelName || "",
          parentId: item.parentId ?? 0,
        },
      },
      () => this.fetchMakes(""),
    );
  };

  onEdit = (selected) => {
    if (selected?.[0]) {
      this.makeSelection(selected[0]);
    }
  };

  ug_submit = () => {
    const itemId = this.state.selectedModel.id;
    const parentId = this.state.form.parentId ?? this.state.selectedModel.parentId ?? 0;
    const obj = modelDataFormat(this.state.form, parentId, itemId);

    fetch(`/api/models/${itemId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.status === "success") {
          toast.success(this.props.translate("updatedSuccessfully"));
        } else if (res?.statusCode === "440") {
          window.location.replace("/login");
        } else if (res.statusCode) {
          const err = res?.message?.split(":");
          if (err?.[1]) {
            toast.error(this.props.translate(err[1].replace(")", "")));
          }
        }
      })
      .catch(() => {
        toast.error(this.props.translate("somethingwentWrong"));
      });

    this.setState(
      {
        addOption: false,
        editOption: false,
        form: { ...formDefaultState },
        defaultModelList: true,
        allMakes: [],
      },
      () => this.getModelsData(),
    );
  };

  render() {
    const rowDefinition = [
      {
        id: "makeName",
        numeric: false,
        disablePadding: false,
        label: this.props.translate("makeName"),
      },
      {
        id: "modelName",
        numeric: false,
        disablePadding: false,
        label: this.props.translate("modelName"),
      },
    ];

    const modalProps = {
      handleChange: this.handleChange,
      handleMakeChange: this.handleMakeChange,
      form: this.state.form,
      modalControle: this.modalControle,
      translate: this.props.translate,
      allMakes: this.state.allMakes,
      makesLoading: this.state.makesLoading,
      searchMakesList: this.searchMakesList,
      loadMoreMakes: this.loadMoreMakes,
    };

    return (
      <div style={{ position: "relative" }}>
        {this.state.addOption && (
          <AddModelModal
            {...modalProps}
            title={this.props.translate("addModel")}
            formSubmit={this.ag_submit}
            buttonText={this.props.translate("sharedCreate")}
            isVisableCreateBtn={this.state.isVisableModelBtn}
          />
        )}

        {this.state.editOption && (
          <AddModelModal
            {...modalProps}
            title={this.props.translate("editModel")}
            formSubmit={this.ug_submit}
            buttonText={this.props.translate("update")}
            isVisableCreateBtn={this.state.isVisableModelBtnforEdit}
          />
        )}

        {this.state.defaultModelList ? (
          <>
            <Grid container className="breadcrumb-row">
              <Grid item xs={12} sm={4}>
                <h3 style={{ margin: 0 }}>
                  {this.props.translate("vehicleModels")}
                </h3>
              </Grid>
              <Grid item xs={12} sm={8} style={{ justifyContent: "flex-end" }}>
                <div style={{ width: "25%", marginRight: 20 }}>
                  <TextField
                    fullWidth
                    label={this.props.translate("search")}
                    value={this.state.itemSearch || ""}
                    onChange={(e) => this.SearchItem(e.target.value)}
                  />
                </div>
                <Button
                  aria-label="Create"
                  size="small"
                  color="inherit"
                  onClick={this.addModel}
                  id="createButton"
                >
                  {this.props.translate("create")}
                </Button>
              </Grid>
            </Grid>
            {this.state.loading ? (
              <Loader />
            ) : (
              <Table
                rows={this.state.tableData || []}
                pagination={this.setPagination(this.state.pagData)}
                handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                handleChangePage={this.handleChangePage}
                SearchItem={this.SearchItem}
                onDelete={this.removeModel}
                onEdit={this.onEdit}
                themecolors={this.props.themecolors}
                isRowIcons={false}
                isCursoPointer
                filterDropdown
                setSerialNo
                rowDefinition={rowDefinition}
                hasAccessOfDelete={true}
                isEditable={true}
                onClick={this.makeSelection}
              />
            )}
          </>
        ) : (
          !this.state.addOption && !this.state.editOption && <Loader />
        )}

        {this.state.onDeleteConfirmation && (
          <ConfirmDialoag
            onCancel={this.onCancel}
            onOk={this.deleteItem}
            title={this.props.translate("areYouWantToDelete")}
            children={
              this.state.selectedModel?.modelName ||
              this.state.selectedModel?.makeName
            }
          />
        )}
      </div>
    );
  }
}

const mapState = (state) => ({
  logInUser: state.logInUsers,
  themecolors: state.themecolors,
});

export const VehicleModelsList = connect(mapState)(ModelsList);
